module.exports = __webpack_public_path__ + "img/short-form-example-4.17ad9314.png";